export default __webpack_public_path__ + "static/media/34.b00dd394.png";